/* eslint-disable prettier/prettier */
/* eslint-disable indent */
import React, { useState, useEffect } from 'react'
import { NavLink as NL, } from 'react-router-dom'
import { getBuildVersion, getBuildDateTime } from 'configs'
// import { Transition, Spring } from 'react-spring'
// import { TimingAnimation, Easing } from 'react-spring/dist/addons'

import { ROUTES, getRegion } from '../../constants'
import Loading from '../../components/Loading'
import DashboardIcon from 'static/images/icons/poll.svg'
import PatientsIcon from 'static/images/icons/account-search-outline.svg'
import ClinicialIcon from 'static/images/icons/Clinician.svg'
import DropdownIcon from 'static/images/icons/dropdown.svg'
import ReviewIcon from 'static/images/icons/inbox.svg'
import WhiteBG from 'static/images/icons/WhiteBG.svg'
import ReportsIcon from 'static/images/icons/clipboard-pulse-outline.svg'
import SettingsIcon from 'static/images/icons/settings.svg'
import ResourcesIcon from 'static/images/icons/Resources.svg'
import SignOutIcon from 'static/images/icons/logout.svg'
import ReferralsIcon from 'static/images/icons/send.svg'
import KPLogo from 'static/images/kardia_pro_logo.svg'
import FeedbacksIcon from 'static/images/icons/feedbacks.svg'
import Teleconnect from 'static/images/icons/teleconnect.svg'
import SupportIcon from 'static/images/support.svg'
import ConsultationsIcon from 'static/images/icons/ConsultationIcon.svg'
import CalendarIcon from 'static/images/icons/VectorIcon.svg'
import MenuIcon from 'static/images/menu.svg'
import KPCollapse from 'static/images/back.svg'
import KardiaRx from 'static/images/kardia-rx.svg'
import styles from './NavigationSidebar.css'
import history from '../../containers/History'






const TeamProfile = props => {
  const {
    me,
    sidebarIsCollapsed,
    handleToggleNavigationSidebar,
  } = props
  const {
    isFetching,
    data,
  } = me

  let teamName = ''
  let initials = ''
  let fName = ''
  let lName = ''
  let avatar

  if (!data) {
    teamName = ''
  } else {
    const {
      name,
      logoURL,
    } = data.teams[0]
    const {
      firstName,
      lastName,
    } = data.profile
    teamName = name
    fName = firstName
    lName = lastName
    initials = firstName.charAt(0) + lastName.charAt(0)
    const avatarClassName = sidebarIsCollapsed ? 'avatarCollapsed' : 'avatar'
    const initialsClassName = sidebarIsCollapsed ? 'initialsCollapsed' : 'initials'

    if (logoURL) {
      avatar = <img className={styles[avatarClassName]} src={logoURL} />
    } else {
      avatar = <div className={styles[initialsClassName]}><span><div>{initials}</div></span></div>
    }
  }

  const profileClassName = sidebarIsCollapsed ? 'profileCollapsed' : 'profile'
  const mainLogoClassName = sidebarIsCollapsed ? 'mainLogoCollapsed' : 'mainLogo'

  return (
    <React.Fragment>
      <div className={styles[mainLogoClassName]}>
        {
          sidebarIsCollapsed ?
            <span onClick={() => { handleToggleNavigationSidebar() }}><MenuIcon /></span>
            :
            <React.Fragment>
              <KPLogo /> <span onClick={() => { handleToggleNavigationSidebar() }}><KPCollapse /></span>
            </React.Fragment>
        }
      </div>
      <div className={styles[profileClassName]}>
        {data
          ? (
            <div>
              {avatar}
              {
                !sidebarIsCollapsed &&
                <div>
                  <h2 className={styles.userName}>{fName} {lName}</h2>
                  <h2 className={styles.teamName}>
                    {teamName}<br />
                  </h2>
                </div>
              }
            </div>
          )
          : (
            <div className={styles.loader}>
              <Loading />
            </div>
          )
        }
      </div>
    </React.Fragment>
  )
}

const renderLinkContent = props => {
  const {
    Icon,
    text,
    secondaryBullet = false,
    count = false
  } = props

  return (
    <div className={styles.leftGroup}>
      {Icon &&
        <div className={styles.navIcon}>
          <Icon />
        </div>
      }
      {secondaryBullet &&
        <div className={styles.bullet} />
      }
      <span className={styles.navText}>{text}</span>
    </div>
  )
}

const NavLink = props => {
  const {
    className,
    activeClassName,
    to,
    href,
    drop,
    onClick,
    target = '',
  } = props

  if (href) {
    return (
      <a href={href} className={styles.navExtLink} target={target}>
        {renderLinkContent(props)}
      </a>
    )
  }

  return (
    <NL
      className={className}
      activeClassName={activeClassName}
      onClick={e => {
        if (typeof onClick === 'function') {
          onClick()
        }
      }}
      to={to}
    >
      {renderLinkContent(props)}
    </NL>
  )
}

const Navigation = props => {
  const {
    me,
    handleLogout,
    ekgReviewHandleOnNavClick,
    qtEkgReviewHandleOnNavClick,
    KardiaRxHandleOnNavClick,
    patientDirectoryHandleOnNavClick,
    appointmentsHandleOnNavClick,
    overviewHandleOnNavClick,
    reportsHandleOnNavClick,
    settingsHandleOnNavClick,
    sidebarIsCollapsed,
  } = props
  const [ toggle, Settoggle ] = useState(0)


  useEffect(() => {
    if (window.location.pathname.includes('/clinician/ecglist') && toggle === 0) {
      Settoggle(1)
    }
  }, [ window.location.pathname, toggle ])


  const checkFeature = name => {
    const feature = features.find(feat => feat.feature === name)
    return feature ? feature.enabled : false
  }
  const getPermission = name => (me.data ? Object.prototype.hasOwnProperty.call(me.data.profile.permissions, name) && me.data.profile.permissions[name] : false)

  const hasPermissions = me && me.data && Object.keys(me.data.profile.permissions).length > 0
  const isAdmin = getPermission('isAdmin')
  // localStorage.setItem('scripload', false);
  const isPhysician = getPermission('isPhysician')
  const isScreener = getPermission('isScreener')
  const features = me.data ? me.data.teams[0].features : []
  const inventoryEnabled = checkFeature('inventory')
  const licenseManagementEnabled = checkFeature('license-management')
  const isBackOfficeAdmin = getPermission('isBackOfficeAdmin')
  const rpmEnabled = checkFeature('rpm')
  const referralsEnabled = checkFeature('referral')
  const serviceProviderEnabled = checkFeature('qt-service-provider')
  const idtfEnabled = checkFeature('idtf')
  const idtfServiceProviderEnabled = checkFeature('idtf-service-provider')
  const teleconnectEnabled = checkFeature('teleconnect')
  const clinicianEnabled = checkFeature('clinician-review-portal')
  const isProd = process.env.REACT_APP_API_ENV === 'production'
  const buildInfoStyles = `${styles.buildInfo} ${isProd ? styles.production : ''}`
  const isUsRegion = getRegion() === 'us'

  const getClassNameQt = () => (window.location.pathname.includes('ekg-review/recordings') ? 'sidebarItemActiveOverride' : 'sidebarItem')

  const inventoryLink = (
    <li data-action="page-navigation" data-label="Inventory">
      <NavLink
        className={styles.sidebarItem}
        activeClassName={styles.sidebarItemActive}
        to={licenseManagementEnabled ? ROUTES.INVENTORY_LMP : ROUTES.INVENTORY_IMP}
        Icon={ReviewIcon}
        text="Inventory"
      />
    </li>
  )
  const dashboardLink = (
    <li data-action="page-navigation" data-label="Dashboard">
      <NavLink
        className={styles.sidebarItem}
        activeClassName={styles.sidebarItemActive}
        to={ROUTES.DASHBOARD}
        onClick={overviewHandleOnNavClick}
        Icon={DashboardIcon}
        text="Dashboard"
      />
    </li>
  )
  const patientsLink = (
    <li data-action="page-navigation" data-label="Patients">
      <NavLink
        className={styles.sidebarItem}
        activeClassName={styles.sidebarItemActive}
        to={ROUTES.PATIENTS}
        onClick={patientDirectoryHandleOnNavClick}
        Icon={PatientsIcon}
        text="Patients"
      />
    </li>
  )
  const inboxLink = (
    <li data-action="page-navigation" data-label="ECG Inbox">
      <NavLink
        className={styles.sidebarItem}
        activeClassName={styles.sidebarItemActive}
        to={ROUTES.EKG_REVIEW}
        onClick={() => ekgReviewHandleOnNavClick(true, false)}
        Icon={ReviewIcon}
        text="ECG Inbox"
      />
    </li>
  )
  const reportsLink = (
    <li data-action="page-navigation" data-label="Reports">
      <NavLink
        className={styles.sidebarItem}
        activeClassName={styles.sidebarItemActive}
        to={ROUTES.REPORTS}
        onClick={() => reportsHandleOnNavClick(true, false)}
        Icon={ReportsIcon}
        text="Reports"
      />
    </li>
  )
  const showRPM = !idtfServiceProviderEnabled && rpmEnabled
  /*  Hiding RPM is based on a user being able to see the inventory management
      screen because pure IM users should not see the rest of the content.
  */
  const hideRPM = isBackOfficeAdmin && !(isAdmin || isPhysician || isScreener)

  return (
    <React.Fragment>
      <ul className={styles.navList}>
        {(inventoryEnabled || licenseManagementEnabled) && isBackOfficeAdmin && inventoryLink}

        {showRPM && !hideRPM && (
          <React.Fragment>
            { dashboardLink }
            { patientsLink }
          </React.Fragment>
        )}
        {!idtfServiceProviderEnabled && !inventoryEnabled && clinicianEnabled && (
          <React.Fragment>
            <li>
              <span onClick={() => Settoggle(!toggle)}>
                <div className={styles.leftGroup}>
                  {ClinicialIcon && (
                    <div className={styles.navIcon}>
                      <ClinicialIcon />
                    </div>
                  )}
                  <span className={styles.navText}>Clinician Review</span>
                  {toggle ? (
                    <div className={styles.dropdown}>
                      <DropdownIcon />
                    </div>
                  ) : (
                    <div />
                  )}
                </div>
              </span>
              <ul className={toggle ? styles.dropDown : styles.dropDownHide}>
                {(isPhysician || isAdmin) && (
                  <React.Fragment>
                    <li>
                      <NavLink
                        className={styles.sidebarItem}
                        activeClassName={styles.sidebarItemActive}
                        to={
                          isPhysician && !isAdmin
                            ? ROUTES.CLINICIAN_ECGLIST
                            : ROUTES.CLINICIAN_ADMIN_ECGLIST
                        }
                        onClick={appointmentsHandleOnNavClick}
                        text="EKG Worklist"
                        Icon={WhiteBG}
                      />
                    </li>
                    <li>
                      <NavLink
                        className={styles.sidebarItem}
                        activeClassName={styles.sidebarItemActive}
                        to={ROUTES.CLINICIAN_STETH_LIST}
                        onClick={appointmentsHandleOnNavClick}
                        text="StethIO Worklist"
                        Icon={WhiteBG}
                      />
                    </li>
                  </React.Fragment>
                )}
              </ul>
            </li>
          </React.Fragment>
        )}

        {!idtfServiceProviderEnabled && !inventoryEnabled && teleconnectEnabled && (
          <React.Fragment>
            {isAdmin && (
              <li data-action="page-navigation" data-label="Admin Dashboard">
                <NavLink
                  className={styles.sidebarItem}
                  activeClassName={styles.sidebarItemActive}
                  to={ROUTES.TELEKARDIA_ADMIN_DASHBOARD}
                  onClick={appointmentsHandleOnNavClick}
                  Icon={DashboardIcon}
                  text="Dashboard"
                />
              </li>
            )}
            {isPhysician && (
              <li data-action="page-navigation" data-label="Telekardia">
                <NavLink
                  className={styles.sidebarItem}
                  activeClassName={styles.sidebarItemActive}
                  to={ROUTES.TELEKARDIA_DASHBOARD}
                  onClick={appointmentsHandleOnNavClick}
                  Icon={Teleconnect}
                  text="TeleConnect"
                />
              </li>
            )}
            {isAdmin && (
              <li data-action="page-navigation" data-label="Feedbacks">
                <NavLink
                  className={styles.sidebarItem}
                  activeClassName={styles.sidebarItemActive}
                  to={ROUTES.TELEKARDIA_ADMIN_FEEDBACKS}
                  onClick={appointmentsHandleOnNavClick}
                  Icon={FeedbacksIcon}
                  text="Feedbacks"
                />
              </li>
            )}
            {isAdmin && (
              <li data-action="page-navigation" data-label="Calendar">
                <NavLink
                  className={styles.sidebarItem}
                  activeClassName={styles.sidebarItemActive}
                  to={ROUTES.TELEKARDIA_ADMIN_CALENDAR}
                  onClick={appointmentsHandleOnNavClick}
                  Icon={CalendarIcon}
                  text="Scheduler"
                />
              </li>
            )}
            {isAdmin && (
              <li data-action="page-navigation" data-label="Consultations">
                <NavLink
                  className={styles.sidebarItem}
                  activeClassName={styles.sidebarItemActive}
                  to={ROUTES.TELEKARDIA_ADMIN_CONSULTATIONS}
                  onClick={appointmentsHandleOnNavClick}
                  Icon={ConsultationsIcon}
                  text="Consultations"
                />
              </li>
            )}
          </React.Fragment>
        )}
        {showRPM && !hideRPM && (
          <React.Fragment>
            { inboxLink }
            { reportsLink }
          </React.Fragment>
        )}
        {!idtfServiceProviderEnabled && !inventoryEnabled && serviceProviderEnabled && (
          <li data-action="page-navigation" data-label="ECG Review">
            <NavLink
              className={styles[getClassNameQt()]}
              activeClassName={styles.sidebarItemActive}
              to={ROUTES.QT_EKG_REVIEW}
              onClick={() => qtEkgReviewHandleOnNavClick(true, false)}
              Icon={ReviewIcon}
              text="ECG Review"
            />
          </li>
        )}
        {!idtfServiceProviderEnabled && !inventoryEnabled && referralsEnabled && (
          <li data-action="page-navigation" data-label="Referrals">
            <NavLink
              className={styles.sidebarItem}
              activeClassName={styles.sidebarItemActive}
              href="/recommend"
              Icon={ReferralsIcon}
              text="Recommend"
            />
          </li>
        )}
        {!idtfServiceProviderEnabled && idtfEnabled && (
          <li data-action="page-navigation" data-label="KardiaRx">
            <NavLink
              className={styles.sidebarItem}
              activeClassName={styles.sidebarItemActive}
              to={ROUTES.IDTF_KARDIA_RX}
              onClick={() => history.push(ROUTES.IDTF_KARDIA_RX)}
              Icon={KardiaRx}
              text="KardiaRx"
            />
          </li>
        )}
        {idtfServiceProviderEnabled && (
          <React.Fragment>
            <li data-action="page-navigation" data-label="CCTPatientsList">
              <NavLink
                className={styles.sidebarItem}
                activeClassName={styles.sidebarItemActive}
                to={ROUTES.CCT_PATIENTS_LIST}
                onClick={() => history.push(ROUTES.CCT_PATIENTS_LIST)}
                Icon={KardiaRx}
                text="Patients"
              />
            </li>
            <li data-action="page-navigation" data-label="CCTWorkList">
              <NavLink
                className={styles.sidebarItem}
                activeClassName={styles.sidebarItemActive}
                to={ROUTES.CCT_WORK_LIST}
                onClick={() => history.push(ROUTES.CCT_WORK_LIST)}
                Icon={KardiaRx}
                text="Worklist"
              />
            </li>
          </React.Fragment>
        )}
        {
          (hasPermissions || rpmEnabled) && !idtfServiceProviderEnabled && (
            <li data-action="page-navigation" data-label="Support">
              <NavLink
                className={styles.sidebarItem}
                activeClassName={styles.sidebarItemActive}
                href="https://kardiapro.zendesk.com/"
                target="_blank"
                Icon={SupportIcon}
                text="Support"
              />
            </li>
          )
        }
      </ul>
      {!sidebarIsCollapsed && (
        <div className={buildInfoStyles}>
          Build Info: <br />
          V: {getBuildVersion()}
          <br />
          D: {getBuildDateTime()}
        </div>
      )}
      <div
        className={styles.sidebarFooter}
        style={clinicianEnabled ? { marginTop: '5rem' } : {}}
      >
        {isAdmin && clinicianEnabled && (
          <div
            className={styles.sidebarFooterItem}
            data-action="page-navigation"
            data-label="Settings"
          >
            <NavLink
              className={styles.settings}
              activeClassName={styles.sidebarItemActive}
              to={ROUTES.CLINICIAN_ADMIN_REPORT}
              onClick={() => settingsHandleOnNavClick(true, false)}
              Icon={ReportsIcon}
              text="Reports"
            />
          </div>
        )}
        {clinicianEnabled && isUsRegion && (
          <div className={styles.sidebarFooterItem} data-action="page-navigation" data-label="Settings">
            <NavLink
              className={styles.settings}
              activeClassName={styles.sidebarItemActive}
              to={
                isAdmin
                  ? ROUTES.CLINICIAN_ADMIN_RESOURCE
                  : ROUTES.CLINICIAN_RESOURCE
              }
              onClick={() => settingsHandleOnNavClick(true, false)}
              Icon={ResourcesIcon}
              text="Resources"
            />
          </div>
        )}
        <div
          className={styles.sidebarFooterItem}
          data-action="page-navigation"
          data-label="Settings"
        >
          <NavLink
            className={styles.settings}
            activeClassName={styles.sidebarItemActive}
            to={ROUTES.SETTINGS}
            onClick={() => settingsHandleOnNavClick(true, false)}
            Icon={SettingsIcon}
            text="Settings"
          />
        </div>
        <button
          onClick={handleLogout}
          className={styles.logout}
          data-action="signOut"
        >
          <div className={styles.navIcon}>
            <SignOutIcon />
          </div>
          <span className={styles.navText}>Sign Out</span>
        </button>
      </div>
    </React.Fragment>
  )
}
class NavigationSidebar extends React.PureComponent {
  UNSAFE_componentWillMount() {
    this.props.getNavigationSidebarData()
  }

  render() {
    const {
      sidebarIsCollapsed,
      me,
      handleToggleNavigationSidebar,
    } = this.props

    const sidebarClassName = sidebarIsCollapsed ? 'sidebarCollapsed' : 'sidebar'

    return (
      <React.Fragment>
        <aside data-page="navigation-sidebar" className={styles[sidebarClassName]}>
          <TeamProfile me={me} sidebarIsCollapsed={sidebarIsCollapsed} handleToggleNavigationSidebar={handleToggleNavigationSidebar} />
          <Navigation
            me={me}
            {...this.props}
          />
        </aside>
      </React.Fragment>
    )
  }
}
export default NavigationSidebar



// WEBPACK FOOTER //
// ./src/legacy/containers/NavigationSidebar/NavigationSidebar.jsx